<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"
import { ChevronLeft } from "lucide-vue-next"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <a
    data-slot="pagination-previous"
    aria-label="Go to previous page"
    :class="cn('inline-flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground cursor-pointer', props.class)"
  >
    <ChevronLeft class="size-4" />
    <span>Previous</span>
  </a>
</template>
